import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { t } from 'i18n';

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'running', label: 'Running' },
  { value: 'all', label: 'All' },
];

const JobStatusFilter = ({ value, onChange, sx }) => {
  const handleChange = (_event, nextValue) => {
    if (!nextValue || nextValue === value) return;
    onChange(nextValue);
  };

  return (
    <ToggleButtonGroup
      aria-label={t('Status')}
      exclusive
      onChange={handleChange}
      size="small"
      sx={sx}
      value={value}
    >
      {statusOptions.map(({ value: optionValue, label }) => (
        <ToggleButton aria-label={t(label)} key={optionValue} value={optionValue}>
          {t(label)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

JobStatusFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
};

export default JobStatusFilter;
